import React, { useState, useEffect } from "react";
import useDebounce from "components/customHooks/useDebounce";
import { TextField } from "@mui/material";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { getPatientList } from "apiHandler/actions";
import { useUserData } from "components/customHooks/userDataContext";
import { displayDateFormatter } from "components/helpers";

const PatientPicker = ({ value = {}, setValue, disabled, error }) => {
  const [inputValue, setInputValue] = useState(
    value.patient_id || value.full_name || ""
  );
  const [patient, setPatient] = useState({
    patient_id: value.patient_id || "",
    first_name: "",
    last_name: "",
    dob: null,
    mobile: "",
    home: "",
    full_name: value.full_name,
  });
  const [patients, setPatients] = useState([]);
  const userData = useUserData();
  const token = userData?.access_token;

  useEffect(() => {
    if (value.patient_id !== patient.patient_id) {
      setPatient({
        patient_id: value.patient_id || "",
        first_name: "",
        last_name: "",
        dob: null,
        mobile: "",
        home: "",
        full_name: value.full_name,
      });
      setInputValue(value || "");
    }
  }, [value]);

  useDebounce(
    async () => {
      if (
        inputValue &&
        inputValue !== patient.patient_id &&
        inputValue !== patient.full_name
      ) {
        const payload = {
          practice_id: `${userData?.selected_practice}`,
        };
        if (!isNaN(parseFloat(inputValue[0]))) {
          if (new Date(inputValue) instanceof Date) payload["dob"] = inputValue;
          else return;
        } else payload["name"] = inputValue;
        const response = await getPatientList(payload, token);
        if (!response) return;

        setPatients(
          response.map((patient) => ({
            ...patient,
            patient_id: patient.patient_id,
            full_name: patient.first_name + " " + patient.last_name,
            search_by:
              patient.first_name +
              " " +
              patient.last_name +
              " " +
              displayDateFormatter(patient.dob),
          }))
        );
      }
    },
    1000,
    [inputValue]
  );

  return (
    <Autocomplete
      options={patients}
      getOptionLabel={(option) =>
        option?.search_by ||
        option?.full_name ||
        option?.dob ||
        option?.patient_id ||
        ""
      }
      isOptionEqualToValue={(option, value) =>
        option.patient_id === value.patient_id
      }
      value={patient}
      onChange={(e, n) => {
        if (n) {
          setPatient(n);
          setValue(n);
          setInputValue("");
        } else {
          setValue({
            patient_id: "",
            first_name: "",
            last_name: "",
            dob: null,
            mobile: "",
            home: "",
            full_name: "",
          });
          setPatient({
            patient_id: "",
            first_name: "",
            last_name: "",
            dob: null,
            mobile: "",
            home: "",
            full_name: "",
          });
          setInputValue("");
        }
      }}
      inputValue={inputValue}
      onInputChange={(e, n) => setInputValue(n)}
      autoComplete={true}
      autoHighlight={true}
      autoSelect={true}
      disabled={disabled || false}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          error={error || false}
          InputProps={{
            ...params.InputProps,
            endAdornment: params.InputProps.endAdornment,
          }}
        />
      )}
      // style={{ widht: "100%" }}
      renderOption={(option) => (
        <div
          style={{ flexDirection: "column", alignItems: "flex-start" }}
          key={option.patient_id}
        >
          <p
            style={{
              fontSize: 12,
              margin: 0,
              padding: 0,
            }}
          >
            ID: {option.patient_id}
          </p>
          <p
            style={{
              fontSize: 14,
              margin: 0,
              padding: 0,
            }}
          >
            {option.full_name}
          </p>
          <p
            style={{
              fontSize: 12,
              margin: 0,
              padding: 0,
            }}
          >
            DOB: {displayDateFormatter(option.dob)}
          </p>
        </div>
      )}
    />
  );
};

export default PatientPicker;
